import { GetItemsProps } from 'medere-ui-framework'
import { axiosInstance } from '../App'
import { RoomType } from '../interface/interface'

export interface RoomTypeNomenclatorDTO {
  nomenclator: number
  code: string
  description: string
  codeanddescription: string
}

export type RoomTypeSaveRequest = Pick<RoomType, 'roomtype' | 'description' | 'nomenclator'>

/** Tipos de habitación del site logueado, ordenados por descripción. */
export async function getRoomTypes(): Promise<RoomType[]> {
  const response = await axiosInstance.get('/api/secured/roomtype/getRoomTypes')
  return Array.isArray(response.data) ? response.data : []
}

/** Nomencladores con la etiqueta de internación, para el combo del tipo de habitación. */
export async function getRoomTypeNomenclatorsForCombo({
  filterValue,
  pageSize,
  offSet,
}: GetItemsProps): Promise<RoomTypeNomenclatorDTO[]> {
  const response = await axiosInstance.get('/api/secured/roomtype/getNomenclatorsForCombo', {
    params: {
      inputtext: filterValue ?? '',
      pageSize: pageSize ?? 20,
      offSet: offSet ?? 0,
    },
  })
  return Array.isArray(response.data) ? response.data : []
}

/** Crea (roomtype <= 0) o actualiza un tipo de habitación. 409 → "DUPLICATED". */
export async function saveRoomType(data: RoomTypeSaveRequest): Promise<RoomType> {
  const response = await axiosInstance.post('/api/secured/roomtype/saveRoomType', data)
  return response.data
}

/** Elimina un tipo de habitación. 409 → "IN_USE" si está asignado a habitaciones. */
export async function deleteRoomType(roomTypeId: number): Promise<void> {
  await axiosInstance.delete('/api/secured/roomtype/deleteRoomType', { params: { roomTypeId } })
}
